import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';

// Restreint l'accès aux pages de suivi (tâches / inscrits-désinscrits) aux
// services Relance (id_service 4) et Administrateur (access_level 0).
// Les autres services (ex: Commercial) sont redirigés vers le tableau de bord.
const TaskTrackingGuard = (props) => {
  const { children } = props;
  const { user } = useAuth();

  const canAccess = user && (user.access_level === 0 || user.id_service === 4);

  if (!canAccess) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

TaskTrackingGuard.propTypes = {
  children: PropTypes.node
};

export default TaskTrackingGuard;
